<template>
  <q-layout view="lHh Lpr lFf">
    <Header />
    <q-page-container>
      <q-page padding>
        <div class="row q-pt-lg text-grey-9">
          <div class="col"></div>
          <div class="col-5" style="max-width: 400px">
            <span class="text-h5">Connexion</span>
            <q-separator class="q-mt-sm q-mb-lg"/>
            <!--<ValidationObserver v-slot="{ handleSubmit }">-->
              <q-form
                @submit="onSubmit"
                class="q-pt-sm"
              >
                <!--<ValidationProvider
                  name="email"
                  ref="email"
                  mode="passive"
                  rules="required|email"
                  v-slot="{ errors, invalid, validated }"
                >-->
                  <q-input
                    v-model="email"
                    type="email"
                    label="Email"
                    color="grey-9"
                    clearable
                    filled
                    class="q-mb-md"
                  />
                <!--</ValidationProvider>
                <ValidationProvider
                  name="password"
                  ref="password"
                  mode="passive"
                  rules="required"
                  v-slot="{ errors, invalid, validated }"
                >-->
                  <q-input
                    v-model="password"
                    ref="password"
                    type="password"
                    label="Mot de passe"
                    color="grey-9"
                    clearable
                    filled
                    class="q-mb-md"
                  />
                <!--</ValidationProvider>-->
                <div class="q-gutter-sm">
                  <q-btn
                    label="Se connecter"
                    :disabled="isSubmit"
                    type="submit"
                    class="text-white bg-grey-9"
                  />
                  <q-btn
                    label="Mot de passe oublié ?"
                    :disabled="isSubmit"
                    to="/request-reset-password"
                    color="white"
                    class="q-ml-sm text-grey-9"
                  />
                </div>
              </q-form>
            <!--</ValidationObserver>-->
          </div>
          <div class="col"></div>
        </div>
      </q-page>
    </q-page-container>
  </q-layout>
</template>

<script>
//import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { FormMixin } from '~/mixins';
import Header from '~/components/Header';
import { login, getUser } from '~/services/user';
import { notifyGlobalError } from '~/services/notify';
import { setJWT, removeJwt } from '~/services/api';

export default {
  name: 'login',
  mixins: [FormMixin],
  components: {
    Header,
    /*
    ValidationProvider,
    ValidationObserver
    */
  },
  data() {
    return {
      email: '',
      password: ''
    };
  },
  methods: {
    async processSubmit() {
      await login({
        username: this.email,
        password: this.password
      }).then((response) => {
        if (response.status != 200) {
          this.notifyLoginError()
        } else {
          this.authenticate(response.data.access, response.data.refresh);
        }
      });
    },
    async authenticate(accessToken, refreshToken) {
      this.$store.commit('user/setIsAuthenticated', true)
      this.$store.commit('user/setAccessToken', accessToken)
      this.$store.commit('user/setRefreshToken', refreshToken)
      setJWT(accessToken);
      const resp = await getUser()
        .then((response) => {
          if (response.status != 200) {
            this.notifyLoginError();
            this.cancelAuthentication();
          }
          else {
            this.$store.commit('user/setUser', response.data);
            this.$router.push({name: 'dashboard'});
          }
        })
        .catch(() => {
          this.cancelAuthentication();
        });
    },
    async cancelAuthentication(){
      this.$store.commit('user/unsetUser');
      removeJwt();
    },
    async notifyLoginError(){
      notifyGlobalError('Connexion impossible (vérifiez vos identifiants).');
    }
  }
};
</script>
